export default __webpack_public_path__ + "svg/CompaniesLogos/thinking.svg?13b07d5f";